import { TooltipGroupContextProvider } from "./group-context.js";
import { TooltipGroupCore } from "@videojs/core";
import { useState } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/ui/tooltip/provider.tsx
function TooltipProvider({ delay, closeDelay, timeout, children }) {
	const [group] = useState(() => new TooltipGroupCore({
		delay,
		closeDelay,
		timeout
	}));
	group.setProps({
		delay,
		closeDelay,
		timeout
	});
	return /* @__PURE__ */ jsx(TooltipGroupContextProvider, {
		value: { group },
		children
	});
}
//#endregion
export { TooltipProvider };

//# sourceMappingURL=provider.js.map